import React from "react";
import { FiCheck } from "react-icons/fi";
import {
  StepCircle,
  StepConnector,
  StepDot,
  StepItem,
  StepLabel,
  StepperList,
  StepperWrapper,
} from "./Stepper.styles";

export const STEPS = [
  { id: 1, label: "Korpa" },
  { id: 2, label: "Plaćanje" },
  { id: 3, label: "Potvrda" },
];

const getState = (stepId, currentStep) => {
  if (stepId < currentStep) return "completed";
  if (stepId === currentStep) return "active";
  return "inactive";
};

/*
 * v2 s.9.1: tanka traka bez kutije, bez opisne rečenice.
 * v2 s.13.6: klik na završen korak vodi nazad (onStepClick).
 */
export default function Stepper({ currentStep = 1, onStepClick = null }) {
  return (
    <StepperWrapper>
      <StepperList>
        {STEPS.map((step, idx) => {
          const state = getState(step.id, currentStep);
          const isLast = idx === STEPS.length - 1;
          const connectorCompleted = step.id < currentStep;
          const clickable = state === "completed" && Boolean(onStepClick);

          return (
            <StepItem key={step.id}>
              <StepDot
                $clickable={clickable}
                onClick={() => clickable && onStepClick(step.id)}
              >
                <StepCircle $state={state} aria-current={state === "active"}>
                  {state === "completed" ? <FiCheck /> : step.id}
                </StepCircle>
                <StepLabel $state={state}>{step.label}</StepLabel>
              </StepDot>
              {!isLast && <StepConnector $completed={connectorCompleted} />}
            </StepItem>
          );
        })}
      </StepperList>
    </StepperWrapper>
  );
}
